import * as React from "react";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loading = () => {
  return (
    <React.Fragment>
      <Container
        maxWidth="lg"
        sx={{
          maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          maxHeight: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          paddingLeft: { xs: "0px" },
          paddingRight: { xs: "0px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            top: "50%",
            left: "50%",
            position: "absolute",
            transform: "translate(-50%, -50%)",
            margin: 0,
          }}
        >
          <CircularProgress />
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default Loading;
